<template>
  <div class="thin-scroll" style="max-height: calc(52vh + 4px); overflow: hidden;">
    <div :class="{'filter-region--scrollable': scrollable}">
      <div class="filter-region">
        <base-dropdown
          block
          label="Country"
          :active="isExpanded"
          size="m"
          :class="`filter-region__title ${disabled ? 'filter-region__disabled' : ''}`"
          :show-icon="false"
        />
        <base-transition-expand>
          <div v-if="isExpanded" class="subitem filter-region__options">
            <div class="filter-region__cont">
              <div
                v-for="region in regions"
                :key="region.identifier"
                :class="`filter-region__options__option ${ isRegionSelected(region) && 'filter-region__options__option--selected-region'}`"
                @click="$event => setSelectedRegionIdentifier(region.identifier)"
              >
                <span class="region-radio" /> <span>{{ region.title }}</span>
              </div>
            </div>
          </div>
        </base-transition-expand>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'RegionsFilter',
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
    regions: {
      type: Array,
      default: () => [],
    },
    selectedRegion: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isExpanded() {
      return !this.disabled;
    },
  },
  methods: {
    toggleExpand() {
      if (this.disabled) {
        return;
      }
      this.isExpanded = !this.isExpanded;
    },
    setSelectedRegionIdentifier(identifier) {
      this.$emit('region-select', identifier);
      this.$store.dispatch('catalog/clearFilters', identifier);
      this.$store.dispatch('catalog/setSelectedMainFacetValueId', null);
    },
    isRegionSelected(region) {
      return this.selectedRegion && this.selectedRegion === region.identifier;
    },
  },
};
</script>
  <style lang="scss" scoped>

  .region-radio {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    border-radius: 50%;
    display: flex;
    background-color: white;
    border: solid thin #868686;
  }

  .filter-region {
    &__title{
      margin-top: 0.5rem;
      color: $dark-black;
    }
    &__options {
      display: flex;
      flex-wrap: wrap;
      row-gap: 8px;
      cursor: pointer;

      &__option {
        display: flex;
        flex-direction: row;
        font-family: "SilkaLight";
        font-weight: 400 !important;
        font-size: 14px;
        height: 35px;
        align-content: center;
        flex-wrap:wrap;
        &:hover {
          opacity: 0.6;

          .region-radio {
            border: solid thin #7e7e7e;
          }
        }

        &--selected-region {
          .region-radio {
            position: relative;
            display: flex;
            flex-flow: row;
            justify-content: center;
            align-items: center;
            border: solid 2px $dark-black;

            &:before {
              background-color: $dark-black;
              border-radius: 50%;
              width: 10px;
              height: 10px;
              content: '';
            }

            &:hover {
              background-color: #7e7e7e;
            }
          }
        }
      }
    }
    &--scrollable {
      overflow-y: auto;
      max-height: 100vh;
    }
    &--cont {
      display:flex;
      flex-direction: column;
    }
    &__disabled{
      color: $gray-light-2;
      :hover{
        cursor: not-allowed;
      }
    }
  }
  .subitem{
    max-height: 234px;
    overflow-y: hidden;
  }
  ::v-deep .base-checkbox__button {
    display: flex;
    & .base-checkbox__label {
      display: inline-block;
    }
  }

  ::v-deep .base-text--light{
    font-family: "SilkaMedium"
  }

</style>
